import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "m-auto px-8 md:px-20 pb-8" }
const _hoisted_2 = { class: "py-5 text-2xl font-bold" }
const _hoisted_3 = {
  key: 2,
  class: "my-3 col-span-3"
}
const _hoisted_4 = { class: "grid grid-cols-[repeat(3,_minmax(0,_1fr))_max-content] gap-4 mb-3" }
const _hoisted_5 = { class: "flex flex-col" }
const _hoisted_6 = { class: "flex flex-col" }
const _hoisted_7 = { class: "flex flex-col" }
const _hoisted_8 = { class: "flex items-center" }
const _hoisted_9 = { class: "flex justify-end col-span-4" }
const _hoisted_10 = { class: "flex pt-3 justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Alert = _resolveComponent("Alert")!
  const _component_Field = _resolveComponent("Field")!
  const _component_NextButton = _resolveComponent("NextButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, "Fasce di ricavo per " + _toDisplayString(_ctx.business_unit?.nome), 1),
    (_ctx.success_message)
      ? (_openBlock(), _createBlock(_component_Alert, {
          key: 0,
          class: "bg-next-bri"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.success_message), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!_ctx.can_edit)
      ? (_openBlock(), _createBlock(_component_Alert, {
          key: 1,
          class: "bg-next-orange"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.message), 1)
          ]),
          _: 1
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[2] || (_cache[2] = _createElementVNode("p", { class: "font-bold" }, "Etichetta", -1)),
            _cache[3] || (_cache[3] = _createElementVNode("p", { class: "font-bold" }, "Valore minimo", -1)),
            _cache[4] || (_cache[4] = _createElementVNode("p", { class: "font-bold" }, "Valore massimo", -1)),
            _cache[5] || (_cache[5] = _createElementVNode("p", { class: "font-bold" }, null, -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fasce, (fascia, i) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_Field, {
                    "label-visible": false,
                    placeholder: "Descrizione",
                    errors: _ctx.getErrorsFasce(i, 'descrizione'),
                    modelValue: fascia.descrizione,
                    "onUpdate:modelValue": ($event: any) => ((fascia.descrizione) = $event)
                  }, null, 8, ["errors", "modelValue", "onUpdate:modelValue"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_Field, {
                    "label-visible": false,
                    placeholder: "Minimo",
                    errors: _ctx.getErrorsFasce(i, 'min'),
                    inputAttrs: {min:0,step:'0.01'},
                    modelValue: fascia.min,
                    "onUpdate:modelValue": ($event: any) => ((fascia.min) = $event),
                    type: "number"
                  }, null, 8, ["errors", "modelValue", "onUpdate:modelValue"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_Field, {
                    "label-visible": false,
                    placeholder: "Massimo",
                    errors: _ctx.getErrorsFasce(i, 'max'),
                    inputAttrs: {min:0,step:'0.01'},
                    modelValue: fascia.max,
                    "onUpdate:modelValue": ($event: any) => ((fascia.max) = $event),
                    type: "number"
                  }, null, 8, ["errors", "modelValue", "onUpdate:modelValue"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_NextButton, {
                    variant: "outline-secondary",
                    onClick: ($event: any) => (_ctx.removeFasce(i)),
                    class: "col flex justify-center items-center h-8 w-8"
                  }, {
                    default: _withCtx(() => _cache[0] || (_cache[0] = [
                      _createElementVNode("i", { class: "icon-x" }, null, -1)
                    ])),
                    _: 2
                  }, 1032, ["onClick"])
                ])
              ], 64))
            }), 128)),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_NextButton, {
                variant: "primary",
                onClick: _ctx.addFascia,
                class: "col flex justify-center items-center h-8 w-8"
              }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createElementVNode("i", { class: "icon-croce_quadrata" }, null, -1)
                ])),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_NextButton, {
              class: "px-3 py-2",
              onClick: _ctx.save
            }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createTextVNode("Salva")
              ])),
              _: 1
            }, 8, ["onClick"])
          ])
        ]))
  ]))
}